import { Reveal } from "./Reveal";

export const SectionHeading = ({ eyebrow, title, text, testid }) => (
    <Reveal className="max-w-3xl">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-coral font-medium" data-testid={testid ? `${testid}-eyebrow` : undefined}>
            {eyebrow}
        </p>
        <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-teal leading-[1.08]" data-testid={testid ? `${testid}-title` : undefined}>
            {title}
        </h2>
        {text && (
            <p className="mt-5 text-base sm:text-lg text-charcoal/75 leading-relaxed" data-testid={testid ? `${testid}-text` : undefined}>
                {text}
            </p>
        )}
    </Reveal>
);
